import { render, staticRenderFns } from "./ArtigosHome.vue?vue&type=template&id=1a0eebd7&scoped=true&"
import script from "./ArtigosHome.vue?vue&type=script&lang=js&"
export * from "./ArtigosHome.vue?vue&type=script&lang=js&"
import style0 from "./ArtigosHome.vue?vue&type=style&index=0&id=1a0eebd7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0eebd7",
  null
  
)

export default component.exports